$.fn.MenuComponent = function() {
  let self = this;
  let element_count = self.find('.menu-component__item').length

  self.find('.arrow-next').click(function() {
    var count = parseInt(self.css('--count'));
    var new_count = count + 1
    var max = element_count - parseInt(self.css('--max-num-element'))
    if (new_count <= max) {
      self.css('--count', new_count)
    }

    if (new_count == max) {
      self.find('.arrow-next').addClass('disabled')
    } else {
      self.find('.arrow-next').removeClass('disabled')
    }

    if (new_count == 0) {
      self.find('.arrow-prev').addClass('disabled')
    } else {
      self.find('.arrow-prev').removeClass('disabled')
    }
  })

  self.find('.arrow-prev').click(function() {
    var count = parseInt(self.css('--count'));
    var new_count = count - 1
    var max = element_count - parseInt(self.css('--max-num-element'))
    if (new_count >= 0) {
      self.css('--count', new_count)
    }

    if (new_count == max) {
      self.find('.arrow-next').addClass('disabled')
    } else {
      self.find('.arrow-next').removeClass('disabled')
    }

    if (new_count == 0) {
      self.find('.arrow-prev').addClass('disabled')
    } else {
      self.find('.arrow-prev').removeClass('disabled')
    }
  })

  return function() {
    $(window).on('load orientationchange resize', function(){
      self.removeClass('show-arrows')
      self.removeClass('stand-alone')
      var list_width = self.find('.menu-component__list').width();
      if (list_width > self.width()) {
        self.addClass('show-arrows')
        list_width = self.find('.menu-component__list').width();
        var element_width = self.find('.menu-component__item').first().outerWidth(true);
        var max_els = Math.floor(list_width / element_width)
        var new_element_width = list_width / max_els;
        self.css('--element-width',  new_element_width + 'px');
        self.css('--count', 0);
        self.css('--max-num-element', max_els);
        self.find('.arrow-prev').addClass('disabled')
      } else {
        self.addClass('stand-alone')
      }
    })
    return self
  }()
}
